<template>
  <div>
    <!-- 渲染表格 -->
    <BasicTable
      :isStyleApplied="isStyleApplied"
      searchPlaceholder="名称,执照,地址,经营范围,电话,法人,注册地"
      :tableColumn="tableColumn"
      :tableData="tableData"
      :actions="actions"
      :showAddButton="uBtnPermissionList.includes('operator-add')"
      :tableTitle="tableTitle"
      :showSearch="true"
      :current="current"
      :total="total"
      :size="size"
      @add-item="addItem"
      @detail-item="detailItem"
      @edit-item="editItem"
      @delete-item="deleteItem"
      @search-item="searchItem"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
<!--      <template #extraBtn="scope" >-->
<!--        <el-button  v-if="uBtnPermissionList.includes('operator-approve')&&scope.row.status==0" @click="approvalClick(scope.row)" type="text" size="small">审批</el-button>-->
<!--        &lt;!&ndash; 是否有驳回原因 &ndash;&gt;-->
<!--        <el-button  v-if="uBtnPermissionList.includes('operator-reject')&&scope.row.status==0" @click="rejectClick(scope.row)" type="text" size="small">驳回</el-button>-->
<!--      </template>-->

<!--      <template #customCol>-->
<!--        <el-table-column prop="status" label="状态" align="center" min-width="60" :show-overflow-tooltip="true">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.status === 0">待审批</span>-->
<!--            <span v-if="scope.row.status === 1">已审批</span>-->
<!--            <span v-if="scope.row.status === 2">已驳回</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </template>-->

    </BasicTable>
    <!-- 渲染弹框 -->
    <BasicForm
      :isStyleApplied="isStyleApplied"
      :dialogVisible="dialogVisible"
      :dialogTitle="dialogTitle"
      :formModel="taskForm"
      :btnName="btnName"
      @submit="handleFormSubmit"
      @update:dialogVisible="updateDialogVisible"
      :formRules="formRules"
      ref="myRef"
    >
      <!-- 正常写本页面需要的表单项 -->

      <el-col :span="12">
        <el-form-item label="运营人名称" prop="operatorName" >
          <el-input v-model="taskForm.operatorName" :disabled="ifView" placeholder="请填写运营人名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人简称" prop="simpleOperatorName" >
          <el-input v-model="taskForm.simpleOperatorName" :disabled="ifView" placeholder="请填写运营人简称" minlength="2" maxlength="4"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人执照号" prop="operatorLicense"  :rules="handelType=='add'?operatorRules:handelType=='edit'&&isChangeOperatorLicense?operatorRules:[]">
          <el-input
            v-model="taskForm.operatorLicense"
            :disabled="ifView"
            placeholder="请填写运营人执照号"
          ></el-input>
        </el-form-item>
      </el-col>
<!--      <el-col :span="12">-->
<!--        <el-form-item label="运营人执照号" prop="c"  :rules="handelType=='add'?operatorRules:handelType=='edit'&&isChangeOperatorLicense?operatorRules:[]">-->
<!--          <el-input-->
<!--            @change="handelOperator()"-->
<!--            v-model="taskForm.operatorLicense"-->
<!--            :disabled="ifView"-->
<!--            placeholder="请填写运营人执照号"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
      <el-col :span="12">
        <el-form-item label="运营人注册地" prop="operatorAddress">
          <el-input
            v-model="taskForm.operatorAddress"
            :disabled="ifView"
            placeholder="请填写运营人注册地"
          ></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="经营范围" prop="operatorRange">
          <el-input
            v-model="taskForm.operatorRange"
            :disabled="ifView"
            placeholder="请填写经营范围"
          ></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item
          label="无人机数量"
          prop="uavNumber"
          :rules="[{ required: true, message: '请填写无人机数量', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
        >
          <!-- <el-input-number :disabled="ifView" v-model="taskForm.uavNumber" placeholder="请填写无人机数量"
          :controls="false"></el-input-number> -->
          <el-input v-model="taskForm.uavNumber" :disabled="ifView" placeholder="请填写无人机数量"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="联系方式"
          prop="phone"
          :rules="handelType=='add'?phoneRules:handelType=='edit'&&isChangePhone?phoneRules:[]"
        >
          <el-input v-model="taskForm.phone" :disabled="ifView" placeholder="请填写联系方式"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="法人代表" prop="legalRepre">
          <el-input v-model="taskForm.legalRepre" :disabled="ifView" placeholder="请填写法人代表"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册地" prop="registeredAddress">
          <el-input v-model="taskForm.registeredAddress" :disabled="ifView" placeholder="请填写注册地"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="成立日期" prop="incorporationDate">
          <el-date-picker
            class="formInputClass"
            v-model="taskForm.incorporationDate"
            type="datetime"
            placeholder="请选择成立日期"
            maxlength="200"
            :disabled="ifView"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="注册资本（万元）"
          prop="registeredCapital"
          :rules="[{ required: true, message: '请填写注册资本（万元）', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
        >
          <el-input v-model="taskForm.registeredCapital" :disabled="ifView" placeholder="请填写注册资本（万元）"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="经营范围" prop="operatorRange">
          <el-input
            v-model="taskForm.operatorRange"
            :disabled="ifView"
            placeholder="请填写经营范围"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 20 }"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="执照图片"
          prop="pic"
          :rules="[
            { required: this.imgValid,  trigger: 'change',message: '请上传执照图片'}
          ]"
        >
          <el-upload
            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
            class="upload-demo"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleElementPicChange"
            :disabled="ifView"
          >
            <img v-if="imageUrl" :src="imageUrl" class="uploaded-image" :title="imgTitle"/>
            <div v-else class="upload-placeholder">
              <!-- <i class="el-icon-upload"></i> -->
              <div class="upload-text">
                <span>去上传</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
      </el-col>
    </BasicForm>
    <BasicForm
      :isStyleApplied="isStyleApplied"  
      :dialogVisible="dialogVisible"
      :dialogTitle="dialogTitle"
      :formModel="taskForm"
      :btnName="btnName"
      @submit="handleFormSubmit"
      @update:dialogVisible="updateDialogVisible"
      :formRules="formRules"
      ref="myRef"
      height="800px"
    >
      <!-- 正常写本页面需要的表单项 -->

      <el-col :span="12">
        <el-form-item label="运营人名称" prop="operatorName" >
          <el-input v-model="taskForm.operatorName" :disabled="ifView" placeholder="请填写运营人名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人简称" prop="simpleOperatorName" :rules="[{ required: true, message: '请填写运营人简称', trigger: 'blur' }]" >
          <el-input v-model="taskForm.simpleOperatorName" :disabled="ifView" placeholder="请填写运营人简称" minlength="2" maxlength="4"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人执照号" prop="operatorLicense"  :rules="handelType=='add'?operatorRules:handelType=='edit'&&isChangeOperatorLicense?operatorRules:[]">
          <el-input
            v-model="taskForm.operatorLicense"
            :disabled="ifView"
            placeholder="请填写运营人执照号"
          ></el-input>
        </el-form-item>
      </el-col>
      <!--      <el-col :span="12">-->
      <!--        <el-form-item label="运营人执照号" prop="c"  :rules="handelType=='add'?operatorRules:handelType=='edit'&&isChangeOperatorLicense?operatorRules:[]">-->
      <!--          <el-input-->
      <!--            @change="handelOperator()"-->
      <!--            v-model="taskForm.operatorLicense"-->
      <!--            :disabled="ifView"-->
      <!--            placeholder="请填写运营人执照号"-->
      <!--          ></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="12">
        <el-form-item label="运营人注册地" prop="operatorAddress">
          <el-input
            v-model="taskForm.operatorAddress"
            :disabled="ifView"
            placeholder="请填写运营人注册地"
          ></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="经营范围" prop="operatorRange">
          <el-input
            v-model="taskForm.operatorRange"
            :disabled="ifView"
            placeholder="请填写经营范围"
          ></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item
          label="无人机数量"
          prop="uavNumber"
          :rules="[{ required: true, message: '请填写无人机数量', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
        >
          <!-- <el-input-number :disabled="ifView" v-model="taskForm.uavNumber" placeholder="请填写无人机数量"
          :controls="false"></el-input-number> -->
          <el-input v-model="taskForm.uavNumber" :disabled="ifView" placeholder="请填写无人机数量"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="联系方式"
          prop="phone"
          :rules="handelType=='add'?phoneRules:handelType=='edit'&&isChangePhone?phoneRules:[]"
        >
          <el-input v-model="taskForm.phone" :disabled="ifView" placeholder="请填写联系方式"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="法人代表" prop="legalRepre">
          <el-input v-model="taskForm.legalRepre" :disabled="ifView" placeholder="请填写法人代表"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册地" prop="registeredAddress">
          <el-input v-model="taskForm.registeredAddress" :disabled="ifView" placeholder="请填写注册地"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="成立日期" prop="incorporationDate">
          <el-date-picker
            class="formInputClass"
            v-model="taskForm.incorporationDate"
            type="datetime"
            placeholder="请选择成立日期"
            maxlength="200"
            :disabled="ifView"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="注册资本（万元）"
          prop="registeredCapital"
          :rules="[{ required: true, message: '请填写注册资本（万元）', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
        >
          <el-input v-model="taskForm.registeredCapital" :disabled="ifView" placeholder="请填写注册资本（万元）"></el-input>
        </el-form-item>
      </el-col>
<!--      <el-col :span="12">-->
<!--        <el-form-item label="用户账号" prop="userNo" >-->
<!--          <el-input v-model="taskForm.userNo" :disabled="ifView" auto-complete="off"-->
<!--                    placeholder="请填写用户账号(20字内,唯一)"-->
<!--                    maxlength="20"-->
<!--                    clearable ></el-input>-->
<!--        </el-form-item>-->
<!--      </el-col>定点-->
      <el-col :span="24">
        <el-form-item label="经营范围" prop="operatorRange">
          <el-input
            v-model="taskForm.operatorRange"
            :disabled="ifView"
            placeholder="请填写经营范围"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 20 }"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="执照图片"
          prop="pic"
          :rules="[
            { required: this.imgValid,  trigger: 'change',message: '请上传执照图片'}
          ]"
        >
          <el-upload
            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
            class="upload-demo"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleElementPicChange"
            :disabled="ifView"
          >
            <el-image :preview-src-list="dialogTitle == '查看' ? [imageUrl] : []" v-if="imageUrl" :src="imageUrl" class="uploaded-image" :title="imgTitle"></el-image>
            <div v-else class="upload-placeholder">
              <!-- <i class="el-icon-upload"></i> -->
              <div class="upload-text">
                <span>去上传</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
      </el-col>
    </BasicForm>
  </div>
</template>
<script type="text/javascript">
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";
import { deepCopy } from "@/utils/tools.js";
export default {
  props: {
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
  },
  name: "Operator",
  // 注入公共组件
  components: {
    BasicTable, //公共表格
    BasicForm, //公共弹框
  },
  data() {
    return {
      //存储一下加密之后返回的联系方式/营业执照
      oldPhone:'',
      isChangePhone:false,
      oldOperatorLicense:'',
      isChangeOperatorLicense:false,
      //点击按钮类型
      handelType:'add',

      // ============表格配置信息==============
      // 列配置 label-列名，prop-对应列的字段名
      tableColumn: [
        { label: "运营人名称", prop: "operatorName" },
        { label: "运营人简称", prop: "simpleOperatorName" },
        // { label: "状态", prop: "simpleOperatorName" },
        { label: "运营人执照号", prop: "operatorLicense" },
        { label: "运营人注册地", prop: "operatorAddress" },
        // { label: "经营范围", prop: "operatorRange" },
        { label: "无人机数量", prop: "uavNumber" },
        { label: "联系方式", prop: "phone" },
        { label: "法人代表", prop: "legalRepre" },
        { label: "注册地", prop: "registeredAddress" },
        { label: "成立日期", prop: "incorporationDate" },
        { label: "注册资本（万元）", prop: "registeredCapital" },
      ],
      tableData: [], // 列表内容数据
      actions: [],
      showAddButton: true, //是否展示新增按钮
      tableTitle: "运营人管理", //表格标题

      // ===========表单配置信息===============
      dialogVisible: false, //初始不展示对话框
      dialogTitle: "", //表单标题
      btnName: "", //表单提交按钮名字
      taskForm: {
        operatorName: "",
        operatorLicense: "",
        operatorAddress: "",
        operatorRange: "",
        uavNumber: "",
        phone: "",
        legalRepre:"",
        registeredAddress:"",
        incorporationDate:"",
        registeredCapital:"",
        simpleOperatorName:"",
      }, // 表单数据绑定
      ifView: false, //是否为查看状态
      imageUrl: "",
      imgTitle: '',
      // 定义表单必填校验
      formRules: [
        { label: '运营人名称', prop: 'operatorName' },
        // { label: '运营人执照号', prop: 'operatorLicense' },
        { label: '运营人注册地', prop: 'operatorAddress' },
        { label: '经营范围', prop: 'operatorRange' },
        // { label: '用户账号', prop: 'userNo' },
        // { label: '无人机数量', prop: 'uavNumber' },
        // { label: '联系方式', prop: 'phone' },
        { label: '法人代表', prop: 'legalRepre' },
        { label: '注册地', prop: 'registeredAddress' },
        { label: '成立日期', prop: 'incorporationDate' },
        // { label: '注册资本（万元）', prop: 'registeredCapital' },
      ],
      imgValid: true, // 校验图片
      total: 0, //总条数
      current: 1, //当前页数
      size: 18, //显示几条
      phoneRules: [], //联系方式校验
      operatorRules: [{ required: true, message: '请填写运营人执照号', trigger: 'change' }],
      searchKey: '', //模糊搜索关键字
    };
  },
  watch: {
    imageUrl(newVal, oldVal) {
      // console.log('new-->',newVal,'old-->',oldVal)
      if (newVal !== '') {
        this.imgValid = false;
      } else {
        this.imgValid = true;
      }
    },
    "taskForm.operatorLicense":{
      handler(v){
        if(v!== this.oldOperatorLicense){
          this.isChangeOperatorLicense = true
        }
      }
    },
    "taskForm.phone":{
      handler(v){
        if(v!==this.oldPhone){
          this.isChangePhone = true
        }
      }
    }
  },
  mounted() {
    // 请求表格配置和数据
    this.$nextTick(function () {
      this.uBtnPermissionList.includes('opeartor-check')&&this.actions.push({ label: "查看", type: "view" })
      this.uBtnPermissionList.includes('operator-modify')&&this.actions.push({ label: "修改", type: "edit" })
      this.uBtnPermissionList.includes('operator-delete')&&this.actions.push({ label: "删除", type: "delete" })
      this.getOperator();
    });
    //this.getTable()
  },
  computed: {
    uBtnPermissionList() {
      return  this.getPageBtnRole('operatorManagement')||[]
    },
  },
  methods: {
    // handelOperator(){
    //   console.log(12)
    //   this.oldOperatorLicense = true
    // },
    approvalClick(v){
      this.dialogVisible = true;
      this.dialogTitle = "运营人审批";
      this.btnName = "审批";
      this.ifView = true; //仅查看，不可编辑
      this.taskForm = { ...v };
      this.imageUrl = "/minio/" + v.licensePhotoUrl;
      this.ifView = true
    },
    rejectClick(v){
      this.$confirm("是否确认驳回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        type: "warning"
      }).then(()=>{
          this.getRequest(
            "/user-server/Operator/refuseById?id=" + v.id,
          ).then((res)=>{
              let oData = res.data;
              if (oData.code === 0) {
                this.$message.success({
                  message: oData.msg,
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {
                  },
                });
                // 成功后刷新
                this.getOperator();
                this.dialogVisible = false;
              }else {
                this.$message.error({
                  message: oData.msg,
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              }
          })
      })

    },
    updateDialogVisible(newVal) {
      this.dialogVisible = newVal;
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.getOperator();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.getOperator();
    },
    getOperator() {
      this.getRequest("/user-server/Operator/queryAllOperator?current="+ this.current + "&size=" + this.size + "&keyword=" + this.searchKey)
      .then((res) => {
        let oData = res.data;
        if (0 == oData.code) {
          if (oData.data) {
              this.tableData = oData.data.records;
              this.total = oData.data.total;
              this.size = oData.data.size;
              this.current = oData.data.current;
            } else {
              this.tableData = [];
            }
        }
        else if (oData.code != 401) {
          this.$message.error({
                  message: oData.msg,
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
        }
      });
    },
    // 新增 打开弹框，如有下拉选项等数据可在此发请求加载
    addItem() {
      this.handelType = 'add'
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.btnName = "提交"; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.imageUrl = "";
      this.resetForm();
      this.phoneRules = [{ required: true, message: '请填写联系方式', trigger: 'change' }, { validator: this.validateNumber, trigger: 'change' },{message: '联系方式为10-12位',max:12,min:10}];
    },
    // 重置表单
    resetForm() {
      this.taskForm = {
        operatorName: "",
        operatorLicense: "",
        operatorAddress: "",
        operatorRange: "",
        uavNumber: "",
        phone: "",
        legalRepre:"",
        simpleOperatorName:"",
        registeredAddress:"",
        incorporationDate:"",
        registeredCapital:"",
      };
    },
    // 查看
    detailItem(item) {
      this.handelType = 'view'
      this.dialogVisible = true;
      this.dialogTitle = "查看";
      this.btnName = "关闭";
      this.ifView = true; //仅查看，不可编辑
      this.taskForm = { ...item };
      this.imageUrl = "/minio/" + item.licensePhotoUrl;
      this.imgTitle = '';
      this.phoneRules = [{ required: true, message: '请填写联系方式', trigger: 'change' }];

    },
    // 修改 TODO
    editItem(item) {
      this.handelType = 'edit'
      this.isChangeOperatorLicense = false
      this.isChangePhone = false
      this.oldPhone = item.phone;
      this.oldOperatorLicense = item.operatorLicense;
      this.dialogVisible = true;
      this.dialogTitle = "修改";
      this.btnName = "提交"; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.taskForm = { ...item };
      this.imageUrl = "/minio/" + item.licensePhotoUrl;
      this.imgTitle = '单击图片可修改';
      this.phoneRules = [{ required: true, message: '请填写联系方式', trigger: 'change' }, { validator: this.validateNumber, trigger: 'change' },{message: '联系方式为10-12位',max:12,min:10}];
    },
    // // 删除
    async deleteItem(itemId) {
      try {
        this.deleteRequest(
          "/user-server/Operator/deleteOperatorById?id=" + itemId
        ).then((res) => {
          const oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 删除成功后刷新
            this.getOperator();
          } else {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            })
          }
        })
      } catch (error) {
        console.error("删除失败", error);
      }
    },

    // 点击确认
    async handleFormSubmit(params) {
      if(!this.isChangePhone){
        params.phone =''
      }
      if(!this.isChangeOperatorLicense){
            params.operatorLicense =''
      }
      params.incorporationDate = this.$moment(params.incorporationDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      // 处理表单提交，根据 dialogTitle 判断是新增还是编辑操作
      if (this.dialogTitle === "新增") {
        const multiData = this.formatSubmitData(deepCopy(params));
        this.postJsonRequest(
          "/user-server/Operator/addOperator",
          multiData
        ).then((res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 新建成功后刷新
            this.getOperator();
          } else  {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        });
      }
      else if (this.dialogTitle === "修改") {
        //delete params.updateTime;
        // 执行修改操作 请求后端接口
        delete params.updateTime;
        const multiData = this.formatSubmitData(deepCopy(params));
        this.putJsonRequest(
          "/user-server/Operator/updateOperator",
          multiData
        ).then((res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 修改成功后刷新
            this.getOperator();
          } else if (oData.code != 401) {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        });
      }
      else if (this.dialogTitle === "查看") {
        // 执行查看操作
        //查看直接回显，无需操作
      }
      else if(this.dialogTitle === "运营人审批"){
        this.getRequest(
          "/user-server/Operator/approveById?id=" + params.id,
        ).then((res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
            });
            // 修改成功后刷新
            this.getOperator();
          }else {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        });
      }
      this.dialogVisible = false;
    },

    formatSubmitData(commonForms) {
      const formData = new FormData();
      const commonForm = commonForms;
      for (const key in commonForm) {
        if (commonForm.hasOwnProperty(key)) {
          const element = commonForm[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      return formData;
    },

    // 上传图元图片改变时执行的事件
    handleElementPicChange(file) {
      const isJPGPNG = file.type === "image/jpeg" || "image/png";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPGPNG) {
        let tips =
          "<i class='el-icon-warn-tip'></i>" +
          "上传图元图片只能是 JPG 或 png 格式!";
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }
      if (!isLt1M) {
        let tips =
          "<i class='el-icon-warn-tip'></i>" + "上传图元图片大小不能超过 1MB!";
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }

      if (isJPGPNG && isLt1M) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.taskForm.file = file.raw;
        this.$nextTick(() => {
          this.$refs.myRef.$refs.formRef.clearValidate('pic'); // 清除校验
        });
      }
    },
    searchItem(val) {
      //模糊搜索
      // console.log(val);
      this.searchKey = val;
      this.getOperator();
    },
    // 数字校验
    validateNumber(rule, value, callback) {
      if (value === '' || !/^\d+$/.test(value)) {
        callback(new Error('请填写有效的数字'));
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped>
.upload-demo {
  width: 120px;
  height: 120px;
  position: relative;
  overflow: hidden; /* 裁剪超出部分 */
  /* border: 1px solid #1D6DC8; */
  background: rgba(1,10,18,0.68);
  /* border-radius: 6px; */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
>>> .el-form {
  height: 533px !important;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-placeholder .el-icon-upload {
  font-size: 32px;
}

.upload-placeholder .upload-text {
  /* margin-top: 8px; */
  font-size: 16px;
  color: #00AEFF;
}

.uploaded-image {
  width: 120px;
  height: 120px;
  object-fit: contain;   /* 保持比例，完整显示，可能有空白 */
  display: flex;        /* 移除底部间隙 */
}
.uploaded-image >>> .el-image__inner {
  max-height: 100% !important;
  max-width: 100% !important;
  object-fit: contain !important;
  height: auto !important; /* 重置默认height */
}

>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    padding: 20px 20px 0px 40px ;
    background: url(../../assets/img/2dmap/pop_bg.png)  no-repeat;
    background-position: 18px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Operator.vue